import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setMenuVisible } from 'header/header/containers/header-actions';
import MainMenu from '../components/main-menu';
import { fetchNavigationalInfo } from './navigation-actions';

class MainMenuContainer extends Component {
  componentWillMount() {
    if (
      (!this.props.activeContext || this.props.shouldNavigationUpdate || this.props.forceActive) &&
      this.props.id
    ) {
      this.props.fetchNavigationalInfo({
        id: this.props.id,
        type: this.props.type,
        context: this.props.activeContext,
        forceActive: this.props.forceActive || false,
        technician: this.props.activeTechnician,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    // TODO: check if this is not an anti-pattern
    // if there is a route change (new id or type),
    // refetch the navigation data.
    if (nextProps.activeContext !== this.props.activeContext && this.props.id) {
      this.props.fetchNavigationalInfo({
        id: nextProps.id,
        type: nextProps.type,
        context: nextProps.activeContext,
        forceActive: nextProps.forceActive || false,
        technician: nextProps.activeTechnician,
      });
    }
  }

  render() {
    return <MainMenu {...this.props} />;
  }
}

MainMenuContainer.propTypes = {
  fetchNavigationalInfo: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  id: PropTypes.string,
  activeContext: PropTypes.string.isRequired,
  shouldNavigationUpdate: PropTypes.bool.isRequired,
  forceActive: PropTypes.bool,
  activeTechnician: PropTypes.string,
};

const mapStateToProps = state => ({
  navigationParents: state.navigation.navigationParents,
  navigationChilds: state.navigation.navigationChilds,
  navigationSelf: state.navigation.navigationSelf,
  activeContext: state.navigation.activeContext,
  activeTechnician: state.navigation.activeTechnician,
  shouldNavigationUpdate: state.navigation.shouldNavigationUpdate,
  expand: state.navigation.expand,
  loading: state.navigation.loading,
  error: state.navigation.error,
  menuVisible: state.header.menuVisible,
  planningBoardFullScreen: state.planningBoard.fullScreen,
  activeServiceCenter: state.serviceCenter.activeServiceCenter,
  adminFor: state.user.adminFor,
  serviceCenters: state.user.serviceCenters,
});

const mapDispatchToProps = {
  fetchNavigationalInfo,
  setMenuVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainMenuContainer);
